import React from 'react';
import logo from '../assets/revupai-logo.png';

export default function Logo({ size = 32 }) {
  return (
    <img
      src={logo}
      alt="RevUpAI"
      style={{
        display: 'block',
        height: size,
        width: 'auto',
        objectFit: 'contain',
        flexShrink: 0,
      }}
    />
  );
}
